////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Application entrypoint                                          //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
